import { AUTH0_SESSION_ACTIVE, EXPIRES_AT_COOKIE, LOGIN_HINT_COOKIE } from '@digitools/auth0-token-manager';
import { clearCookie } from 'src/utils/cookieUtils';
import { isSamlpEntryPath } from 'src/utils/NavigationUtils';
const TOKEN_MANAGER_COOKIES = [AUTH0_SESSION_ACTIVE, EXPIRES_AT_COOKIE, LOGIN_HINT_COOKIE];
let staleSessionCleared = false;
// An SSO entry or auth callback is a fresh login, so leftover session state from a tab closed
// without logout must not be trusted. Once per page load: a repeat init() must not wipe the new session.
export const clearStaleLocalSession = (pathname) => {
    const isFreshAuthentication = isSamlpEntryPath(pathname) || pathname === '/v2/callback';
    if (!isFreshAuthentication || staleSessionCleared)
        return;
    staleSessionCleared = true;
    TOKEN_MANAGER_COOKIES.forEach(name => clearCookie(name));
    localStorage.removeItem('mlpDomain');
    sessionStorage.removeItem('mlpBearerToken');
};
